import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0342814"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  id: "outputOptionModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Output Options"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = {
  class: "form-label",
  for: "presicionSelect"
}
const _hoisted_7 = { class: "px-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "w-100 d-flex justify-content-between p-0 m-0",
  style: {"list-style-type":"none","font-size":"small"}
}, [
  /*#__PURE__*/_createElementVNode("li", null, "low"),
  /*#__PURE__*/_createElementVNode("li", null, "medium"),
  /*#__PURE__*/_createElementVNode("li", null, "high")
], -1))
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "presicionSelect"
}, "Output Format:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: true }, "Binary", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "form-check form-switch mb-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "internalOnlySwitch"
}, "Export Internal Structures Only", -1))
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Exposure Penetration Compensation:", -1))
const _hoisted_17 = { class: "form-check form-switch" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "globalEPC"
}, "Global", -1))
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Compensation per layer:", -1))
const _hoisted_21 = { class: "input-group flex-nowrap" }
const _hoisted_22 = ["disabled", "required"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_24 = { class: "form-check form-switch" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Local", -1))
const _hoisted_26 = { class: "row mb-3" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Compensation min.:", -1))
const _hoisted_29 = { class: "input-group flex-nowrap" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_32 = { class: "col" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "at:", -1))
const _hoisted_34 = { class: "input-group flex-nowrap" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_37 = { class: "row mb-4" }
const _hoisted_38 = { class: "col" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Compensation max.:", -1))
const _hoisted_40 = { class: "input-group flex-nowrap" }
const _hoisted_41 = ["min", "disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_43 = { class: "col" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "at:", -1))
const _hoisted_45 = { class: "input-group flex-nowrap" }
const _hoisted_46 = ["min", "disabled"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_48 = { class: "form-check form-switch" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "aiEPC"
}, "AI", -1))
const _hoisted_50 = {
  key: 0,
  class: "mt-2 p-2 border rounded",
  style: {"background-color":"#f8f9fa"}
}
const _hoisted_51 = { class: "d-flex align-items-center mb-1" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "AI Model Status:", -1))
const _hoisted_53 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_54 = { class: "text-muted" }
const _hoisted_55 = {
  key: 0,
  class: "progress mt-1",
  style: {"height":"4px"}
}
const _hoisted_56 = {
  key: 1,
  class: "alert alert-danger py-1 px-2 mb-1",
  style: {"font-size":"0.8em"}
}
const _hoisted_57 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-primary" }, "AI Processing...", -1))
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = { class: "mb-3" }
const _hoisted_62 = { class: "form-label" }
const _hoisted_63 = { class: "px-5" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "w-100 d-flex justify-content-between p-0 m-0",
  style: {"list-style-type":"none","font-size":"small"}
}, [
  /*#__PURE__*/_createElementVNode("li", null, "low"),
  /*#__PURE__*/_createElementVNode("li", null, "medium"),
  /*#__PURE__*/_createElementVNode("li", null, "high")
], -1))
const _hoisted_65 = { class: "form-check form-switch my-2" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "aiOffsetSwitch"
}, "Offset", -1))
const _hoisted_67 = { key: 3 }
const _hoisted_68 = { class: "mb-2 row" }
const _hoisted_69 = { class: "col" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Offset min.:", -1))
const _hoisted_71 = { class: "input-group flex-nowrap" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_73 = { class: "col" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "at:", -1))
const _hoisted_75 = { class: "input-group flex-nowrap" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Offset max.:", -1))
const _hoisted_80 = { class: "input-group flex-nowrap" }
const _hoisted_81 = ["min"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_83 = { class: "col" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "at:", -1))
const _hoisted_85 = { class: "input-group flex-nowrap" }
const _hoisted_86 = ["min"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "µm", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_89 = { class: "d-flex justify-content-between align-items-center gap-2" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, " Generate ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_STLPreviewVue = _resolveComponent("STLPreviewVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", { 'xl-width': _ctx.showStlPreview }])
    }, [
      (_ctx.showStlPreview)
        ? (_openBlock(), _createBlock(_component_STLPreviewVue, {
            key: 0,
            onExportStep: _ctx.onExportSTEP,
            "is-exporting-step": _ctx.isExportingStep
          }, null, 8, ["onExportStep", "is-exporting-step"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("form", {
                onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.loadSTL()), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, "Precision: " + _toDisplayString(_ctx.precisionValue[_ctx.precisionIdx]), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-range px-1",
                      type: "range",
                      min: "0",
                      max: "2",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.precisionIdx) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.precisionIdx]
                    ]),
                    _hoisted_8
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("select", {
                    id: "presicionSelect",
                    class: "form-select",
                    "aria-label": "Default select example",
                    required: "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isBinary) = $event))
                  }, _hoisted_12, 512), [
                    [_vModelSelect, _ctx.isBinary]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "internalOnlySwitch",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalOnly) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.internalOnly]
                  ]),
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      id: "globalEPC",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.globalChecked) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.globalChecked]
                    ]),
                    _hoisted_18
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        min: "0",
                        type: "number",
                        step: "50",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.globalCompensation) = $event)),
                        disabled: !_ctx.globalChecked,
                        required: _ctx.globalChecked
                      }, null, 8, _hoisted_22), [
                        [_vModelText, _ctx.globalCompensation]
                      ]),
                      _hoisted_23
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localChecked) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.localChecked]
                    ]),
                    _hoisted_25
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          type: "number",
                          min: "0",
                          step: "50",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localCompensationMin) = $event)),
                          disabled: !_ctx.localChecked,
                          required: ""
                        }, null, 8, _hoisted_30), [
                          [_vModelText, _ctx.localCompensationMin]
                        ]),
                        _hoisted_31
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          type: "number",
                          min: "0",
                          step: "50",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.minAt) = $event)),
                          disabled: !_ctx.localChecked,
                          required: ""
                        }, null, 8, _hoisted_35), [
                          [_vModelText, _ctx.minAt]
                        ]),
                        _hoisted_36
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          type: "number",
                          min: _ctx.localCompensationMin,
                          step: "50",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localCompensationMax) = $event)),
                          disabled: !_ctx.localChecked,
                          required: ""
                        }, null, 8, _hoisted_41), [
                          [_vModelText, _ctx.localCompensationMax]
                        ]),
                        _hoisted_42
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          type: "number",
                          min: _ctx.minAt,
                          step: "50",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.maxAt) = $event)),
                          disabled: !_ctx.localChecked,
                          required: ""
                        }, null, 8, _hoisted_46), [
                          [_vModelText, _ctx.maxAt]
                        ]),
                        _hoisted_47
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "aiEPC",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.aiChecked) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.aiChecked]
                  ]),
                  _hoisted_49
                ]),
                (_ctx.aiChecked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("span", {
                          class: _normalizeClass(["ms-2 badge", _ctx.aiModelLoaded ? 'bg-success' : 'bg-secondary'])
                        }, _toDisplayString(_ctx.aiModelLoaded ? 'Loaded' : 'Not Loaded'), 3)
                      ]),
                      (_ctx.aiProgress)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _createElementVNode("small", _hoisted_54, _toDisplayString(_ctx.aiProgress.message), 1),
                            (_ctx.aiProgress.progress !== undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                  _createElementVNode("div", {
                                    class: "progress-bar",
                                    style: _normalizeStyle(`width: ${_ctx.aiProgress.progress}%`)
                                  }, null, 4)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.aiError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.aiError), 1))
                        : _createCommentVNode("", true),
                      (_ctx.aiProcessing)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_60))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("label", _hoisted_62, "Compensation Precision: " + _toDisplayString(_ctx.precisionCompValue[_ctx.precisionCompIdx]), 1),
                        _createElementVNode("div", _hoisted_63, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-range px-1",
                            type: "range",
                            min: "0",
                            max: "2",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.precisionCompIdx) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.precisionCompIdx]
                          ]),
                          _hoisted_64
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          role: "switch",
                          id: "aiOffsetSwitch",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.offsetChecked) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.offsetChecked]
                        ]),
                        _hoisted_66
                      ]),
                      (_ctx.offsetChecked)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _hoisted_70,
                                _createElementVNode("div", _hoisted_71, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    type: "number",
                                    min: "0",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.offsetMin) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.offsetMin]
                                  ]),
                                  _hoisted_72
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _hoisted_74,
                                _createElementVNode("div", _hoisted_75, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    type: "number",
                                    step: "50",
                                    min: "0",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.offsetMinAt) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.offsetMinAt]
                                  ]),
                                  _hoisted_76
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _hoisted_79,
                                _createElementVNode("div", _hoisted_80, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    type: "number",
                                    min: _ctx.offsetMin,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.offsetMax) = $event))
                                  }, null, 8, _hoisted_81), [
                                    [_vModelText, _ctx.offsetMax]
                                  ]),
                                  _hoisted_82
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_83, [
                                _hoisted_84,
                                _createElementVNode("div", _hoisted_85, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    type: "number",
                                    step: "50",
                                    min: _ctx.offsetMinAt,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.offsetMaxAt) = $event))
                                  }, null, 8, _hoisted_86), [
                                    [_vModelText, _ctx.offsetMaxAt]
                                  ]),
                                  _hoisted_87
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.downloadSVGZip && _ctx.downloadSVGZip(...args)))
                  }, " Download SVG "),
                  _hoisted_90
                ])
              ], 32)
            ])
          ]))
    ], 2)
  ]))
}